// eslint-disable-next-line import/no-anonymous-default-export
export default {
  dashboard: 'Dashboard',
  dashboardDesc: 'Home page - General statistics and summary information',
  customers: 'Customers',
  customersDesc: 'Customer management - Customer information and contact details',
  domains: 'Domains',
  domainsDesc: 'Domain management - Domain tracking, renewal and registration information',
  servers: 'Servers',
  serversDesc: 'Server management - Hosting servers, IP addresses and status',
  companies: 'Companies',
  companiesDesc: 'Company information - Customer company information and management',
  users: 'Users',
  usersDesc: 'User management - System users and permission settings',
  settings: 'Settings',
  settingsDesc: 'System settings - General settings and configuration',
  domainPrices: 'Domain Prices',
  domainPricesDesc: 'Domain prices - Domain extension price definitions',
  hostingPrices: 'Hosting Prices',
  hostingPricesDesc: 'Hosting prices - Hosting package prices and features',
  pricing: 'Pricing',
  registrars: 'Registrars',
  registrarsDesc: 'Registration firms - Domain registrar information and API settings',
  panels: 'Panels',
  calendar: 'Calendar',
  calendarDesc: 'Calendar - Payment dates, receivables and payables calendar',
  maps: 'Maps',
  mapsDesc: 'Map view - Geographic distribution of companies and map analysis',
  dataManagement: 'Data Management',
  dataManagementDesc: 'Data management - Export/Import operations and data backup',
  languages: 'Languages',
  analyses: 'Analyses',
  analysesDesc: 'Payment and revenue analyses - Detailed reports and graphs',
  paymentAnalysis: 'Payment Analysis',
  paymentAnalysisDesc: 'Payment analysis - Customer payments, revenues and statistics',
  accountTracking: 'Account Tracking',
  accountTrackingDesc: 'Account tracking - Receivables, payables and currency management',
  recurringPayments: 'Recurring Payments',
  recurringPaymentsDesc: 'Recurring payments - Monthly/yearly subscription payment management',
  financialTransactions: 'Financial Transactions',
  financialTransactionsDesc: 'Financial transactions - Account tracking, recurring payments and calendar',
  system: 'System'
};
